/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enroll_Scan_DescriptionInputs */

const fr_totp_enroll_scan_description = /** @type {(inputs: Totp_Enroll_Scan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanne ce QR code avec ton application d'authentification (Google Authenticator, Authy, etc.)`)
};

/**

* @param {Totp_Enroll_Scan_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enroll_scan_description = /** @type {((inputs?: Totp_Enroll_Scan_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enroll_Scan_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enroll_scan_description(inputs)
});